import AddMiscForms from '~/app/Pages/WizardMode/components/Forms/modals/AddMiscForms.jsx';
import InfoModal from '~/app/Pages/WizardMode/components/Forms/modals/InfoModal.jsx';

export { AddMiscForms, InfoModal };
